import { KeenIcon, MenuIcon, MenuItem, MenuLink, MenuSub, MenuTitle, MenuSeparator } from '@/components';
import { useAbility } from '@/providers';
import { Can } from '@casl/react';
import { Link } from 'react-router-dom';
import { Mails, Sparkles } from 'lucide-react';

const DropdownCard2 = () => {
  const { ability } = useAbility();
  const canCreateContact = ability.can('handle', 'contact')
  const canCreateMatter = ability.can('handle', 'matter')
  const canCreateInvoice = ability.can('handle', 'invoice')
  const canCreateExpense = ability.can('handle', 'expense')
  const canCreateFlatFee = ability.can('handle', 'flatFee')
  const canHandleMails = ability.can('access', 'mass-mailing')
  const canHandleArReport = ability.can('access', 'ar-reports')
  const canHandleInvoiceReport = ability.can('access', 'invoice-report')
  const canHandleSignatureReport = ability.can('access', 'signature-report')
  const canAccessAdhocReport = ability.can('access', 'adhoc-reports')
  const canHandleIntakeForm = ability.can('handle', 'intake-form')

  return <MenuSub className="menu-default" rootClassName="w-full max-w-[220px] !h-[550px] h-full overflow-y-auto custom-scrollbar">
    {/* Contact - Matter Module */}
    {(canCreateContact || canCreateMatter) && (
      <>
        <div className='menu-link cursor-auto'>
          <MenuIcon>
            <KeenIcon icon="setting-3" />
          </MenuIcon>
          <div className='menu-title'>Get Started</div>
        </div>
        <Can I="handle" a="contact" ability={ability}>
          <Link to='/contacts/create' className='menu-item'>
            <MenuItem>
              <MenuLink>
                <MenuTitle>Create Contact</MenuTitle>
              </MenuLink>
            </MenuItem>
          </Link>
        </Can>
        <Can I="handle" a="matter" ability={ability}>
          <Link to='/matters/create' className='menu-item'>
            <MenuItem>
              <MenuLink>
                <MenuTitle>Create Matter</MenuTitle>
              </MenuLink>
            </MenuItem>
          </Link>
        </Can>
        <MenuSeparator />
      </>
    )}

    {/* Billing - Invoice Module */}
    <div>
      {(canCreateInvoice || canCreateExpense || canCreateFlatFee) && (
        <>
          <div className='menu-link cursor-auto'>
            <MenuIcon>
              <KeenIcon icon="color-swatch" />
            </MenuIcon>
            <div className='menu-title'>Billing</div>
          </div>
          <Can I="handle" a="expense" ability={ability}>
            <Link to='/billing/expense' className='menu-item'>
              <MenuItem>
                <MenuLink>
                  <MenuTitle>Expenses</MenuTitle>
                </MenuLink>
              </MenuItem>
            </Link>
          </Can>
          <Can I="handle" a="flat-fees" ability={ability}>
            <Link to='/billing/flat-fees' className='menu-item'>
              <MenuItem >
                <MenuLink>
                  <MenuTitle>Flat Fees</MenuTitle>
                </MenuLink>
              </MenuItem>
            </Link>
          </Can>
          <Can I="handle" a="invoice" ability={ability}>
            <Link to='/billing/invoice/create' className='menu-item'>
              <MenuItem>
                <MenuLink>
                  <MenuTitle>Create Invoice</MenuTitle>
                </MenuLink>
              </MenuItem>
            </Link>
          </Can>
          <MenuSeparator />
        </>
      )}
    </div>

    {/* Marketing Module (Mass Mailing + Intake Forms) */}
    <div>
      {(canHandleMails || canHandleIntakeForm) && (
        <>
          {/* <div className='menu-link cursor-auto'>
            <div className='menu-title justify-between'>
              Marketing
            </div>
          </div> */}

          {canHandleMails && (
            <>
              <div className='menu-link cursor-auto'>
                <MenuIcon>
                  <KeenIcon icon="sms" />
                </MenuIcon>
                <div className='menu-title'>Mass Mailings</div>
              </div>
              <Link to='/mass-mailing/metrics' className='menu-item'>
                <MenuItem>
                  <MenuLink>
                    <MenuTitle>Email Metrics</MenuTitle>
                  </MenuLink>
                </MenuItem>
              </Link>
              <Link to='/mass-mailing/template-design/create' className='menu-item'>
                <MenuItem>
                  <MenuLink>
                    <MenuTitle>Create Email Template</MenuTitle>
                  </MenuLink>
                </MenuItem>
              </Link>
              <Link to='/mass-mailing/subscription-form/create' className='menu-item'>
                <MenuItem>
                  <MenuLink>
                    <MenuTitle>Create Subscription</MenuTitle>
                  </MenuLink>
                </MenuItem>
              </Link>
              <Link to='/mass-mailing/groups' className='menu-item'>
                <MenuItem>
                  <MenuLink>
                    <MenuTitle>Groups</MenuTitle>
                  </MenuLink>
                </MenuItem>
              </Link>
            </>
          )}

          <MenuSeparator />

          {canHandleIntakeForm && (
            <>
              <div className='menu-link cursor-auto'>
                <MenuIcon>
                  <KeenIcon icon="element-plus" />
                </MenuIcon>
                <div className='menu-title'>Forms</div>
              </div>
              <Link to='/intake-forms' className='menu-item'>
                <MenuItem>
                  <MenuLink>
                    <MenuTitle>Intake Forms</MenuTitle>
                  </MenuLink>
                </MenuItem>
              </Link>
              <Link to='/intake-forms/create' className='menu-item'>
                <MenuItem>
                  <MenuLink>
                    <MenuTitle>Create Intake Form</MenuTitle>
                  </MenuLink>
                </MenuItem>
              </Link>
            </>
          )}

          <MenuSeparator />
        </>
      )}
    </div>

    {/* Reports Module */}
    <div>
      {(canHandleInvoiceReport || canHandleArReport) && (
        <>
          <div className='menu-link cursor-auto'>
            <MenuIcon>
              <KeenIcon icon="graph-up" />
            </MenuIcon>
            <div className='menu-title justify-between'>
              Reports
            </div>
          </div>
          <Can I="access" a="ar-reports" ability={ability}>
            <Link to='/reports/ar-report' className='menu-item'>
              <MenuItem>
                <MenuLink>
                  <MenuTitle>AR Report – Due Invoices</MenuTitle>
                </MenuLink>
              </MenuItem>
            </Link>
          </Can>
          <Can I="access" a="invoice-report" ability={ability}>
            <Link to='/reports/raw-data-report' className='menu-item'>
              <MenuItem >
                <MenuLink>
                  <MenuTitle>Raw Data Report</MenuTitle>
                </MenuLink>
              </MenuItem>
            </Link>
          </Can>
          <Can I="access" a="adhoc-report" ability={ability}>
            <Link to='/reports/adhoc-report' className='menu-item'>
              <MenuItem >
                <MenuLink>
                  <MenuTitle>ADHOC Report</MenuTitle>
                </MenuLink>
              </MenuItem>
            </Link>
          </Can>
          <MenuSeparator />
        </>
      )}
    </div>

    {/* Documents Module */}
    <div>
      {(canHandleSignatureReport) && (
        <>
          <div className='menu-link cursor-auto'>
            <MenuIcon>
              <KeenIcon icon="tablet-text-down" />
            </MenuIcon>
            <div className='menu-title justify-between'>
              Documents
              <span className='inline-flex justify-between gap-1 badge badge-sm badge-pill badge-outline badge-success'>
                <Sparkles className="size-3.5" /> New
              </span>
            </div>
          </div>
          <Can I="access" a="signature-report" ability={ability}>
            <Link to='/documents/e-signature-documents' className='menu-item'>
              <MenuItem >
                <MenuLink>
                  <MenuTitle>E-Signatures</MenuTitle>
                </MenuLink>
              </MenuItem>
            </Link>
          </Can>
          {/* TODO: update permissions once backend is ready */}
          {/* <Can I="access" a="signature-report" ability={ability}> */}
          <Link to='/documents/document-templates' className='menu-item'>
            <MenuItem >
              <MenuLink>
                <MenuTitle>Document Templates</MenuTitle>
              </MenuLink>
            </MenuItem>
          </Link>
          {/* </Can> */}
          <MenuSeparator />
        </>
      )}
    </div>

    {/* Intake Forms module merged into Marketing */}

    {/* TODO: update permissions once backend is ready */}
    {/* Data Import Module */}
    <div>
      {(canHandleSignatureReport) && (
        <>
          <div className='menu-link cursor-auto'>
            <MenuIcon>
              <KeenIcon icon="tablet-down" />
            </MenuIcon>
            <div className='menu-title justify-between'>
              Data Import
              <span className='inline-flex justify-between gap-1 badge badge-sm badge-pill badge-outline badge-success'>
                <Sparkles className="size-3.5" /> New
              </span>
            </div>
          </div>
          {/* <Can I="access" a="signature-report" ability={ability}> */}
          <Link to='/data-import/import' className='menu-item'>
            <MenuItem >
              <MenuLink>
                <MenuTitle>Import Your Data</MenuTitle>
              </MenuLink>
            </MenuItem>
          </Link>
          {/* </Can> */}
          {/* <MenuSeparator /> */}
        </>
      )}
    </div>
  </MenuSub>;
};
export { DropdownCard2 };
